(function() {
'use strict';

// TIMEOUT: how long the widget waits for a reply. 55 s (Nick 2026-09-29; was 30 s, which threw away
// answers that arrived later). NEVER 60 s or more: the store route cuts any reply at 60 s (measured
// 2026-09-29), and the customer would then get "I couldn't reach our chat service" and an outage
// alert would be sent, for a reply that was only slow.
const MAX_TURNS = 20, MAX_CHARS = 500, TIMEOUT = 55000, HEALTH_MS = 300000;
const SKEY = 'psc_chat_v3';
// A phone: up to 500px wide, or a touch screen under 500px tall, i.e. a phone turned sideways
// (Nick 2026-09-28). The two phone @media blocks in the styles above use the same test.
const PHONE_MQ = '(max-width: 500px), (pointer: coarse) and (max-height: 500px)';
// FIRST-PARTY since 2026-08-28: the PSC-Chat-Proxy app forwards this path to
// the chat Worker. Serving from the store's own domain is what ad blockers and
// filter lists were breaking when this pointed at workers.dev (which remains
// live as a manual fallback: swap the URL back and push to revert).
const BASE = 'https://pinestreetclinic.com/apps/chat';
// Test runs open pages with ?psc_eval=<token>; every request then carries it as
// `eval`, and the Worker keeps that traffic out of the digest and the inbox.
// Customers never have it. Kept for the session so navigation does not lose it.
let evalTok=''; try { const q=new URLSearchParams(location.search).get('psc_eval')||''; if(/^[0-9a-f]{16,}$/i.test(q)) evalTok=q; } catch {}
const FALLBACK = 'https://pinestreetclinic.com/pages/contact';
// Proactive auto-open is OFF (Nick 2026-08-28). Baymard's usability testing
// recorded real irritation at self-opening chat ("go away. If I wanted chat I
// would ask for it"), and they specifically recommend suppressing it on cart and
// checkout. Set a value in seconds to re-enable a page type later.
const AUTO_DELAY = { default: 0, product: 0, cart: 0, checkout: 0, order: 0, account: 0 };

let msgs = [], loading = false, open = false, start = new Date().toISOString();
let escShown = false, lastEmail = null, abort = null, lastMsg = null;
let healthy = null, hInterval = null;
// Page refs sent to the Worker: never account/checkout paths, never token-bearing
// query parameters, at most 20 (review 2026-09-23).
// Email addresses never leave the page (Nick 2026-09-27): the tracking page's links carry the
// customer's address, base64-encoded, in `id`. A parameter named like an email, or whose value
// is an email address, plain or base64-encoded, is dropped along with the token-like ones.
function isEmailish(v){ try { v=String(v||''); if(v.includes('@')) return /[^@\s]+@[^@\s]+\.[^@\s]+/.test(v); if(!/^[A-Za-z0-9+/_=-]{12,}$/.test(v)) return false; const b=v.replace(/-/g,'+').replace(/_/g,'/').replace(/=+$/,''); return /^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(atob(b+'='.repeat((4-b.length%4)%4))); } catch { return false; } }
function scrubUrl(u){ for(const [k,v] of [...u.searchParams.entries()]) if(/token|stkn|com_cvv|key|_kx|discount|password|code|e-?mail/i.test(k)||isEmailish(v)) u.searchParams.delete(k); return u; }
function scrubRef(h){ try { const u=scrubUrl(new URL(h)); return u.origin+u.pathname+(u.search||''); } catch { return null; } }
function pageRef(){ try { const u=new URL(location.href); if(/^\/(account|checkouts?)\b/i.test(u.pathname)) return null; return scrubRef(location.href); } catch { return null; } }
function pageUrl(){ return scrubRef(location.href) || (location.origin+location.pathname); }
function notePage(){ const r=pageRef(); if(r&&!pages.includes(r)){ pages.push(r); if(pages.length>20) pages.shift(); } }
let pages = [], lastHref = location.href, autoT = null;
notePage();
let recent = [], cart = null, titles = {};
let sentCount = 0;   // messages already emailed, so we never re-send the same turns

// Helpers
const $ = id => document.getElementById(id);
const esc = t => t.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');

function track(ev, p={}) { try { if (typeof gtag==='function') gtag('event', ev, {event_category:'psc_chat',...p}); } catch{} }

function pType() {
  const p = location.pathname;
  if (p.includes('/products/')) return 'product';
  if (p.includes('/cart')) return 'cart';
  if (p.includes('/checkout')) return 'checkout';
  if (p.includes('/account/orders')||p.includes('/a/track')) return 'order';
  if (p.includes('/account')) return 'account';
  if (p.includes('/collections/')) return 'collection';
  if (p.includes('/pages/help')||p.includes('/pages/faq')) return 'help';
  return 'default';
}

// The AI disclosure opens every conversation (Nick 2026-09-08), then the
// page-aware question. The full disclaimer lives in the footer, permanently.
function greeting() {
  // Nick 2026-09-25: warmer opener, still says AI in the first sentence (the footer
  // keeps "not a person"; the bot says so plainly whenever anyone asks).
  const ai = "Hi there! I'm Pine Street's AI assistant";
  switch(pType()) {
    case 'product': return ai + ". Have a question about this product?";
    case 'cart': return ai + ". Need help before you check out?";
    case 'order': return ai + ". Looking for order or tracking info?";
    case 'collection': return ai + ". Looking for something specific?";
    case 'help': return ai + ". What can I help you find?";
    case 'checkout': return ai + ". Need a hand finishing your order?";
    case 'account': return ai + ". Need help with your account?";
    default: return ai + ", happy to help with our products, orders, and shipping. What can I help you with?";
  }
}

// Session
function save() { try { sessionStorage.setItem(SKEY, JSON.stringify({msgs,escShown,lastEmail,start,pages,titles,recent,sentCount,dropped,open,evalTok})); } catch{} }
let wasOpen=false; // panel state from the PREVIOUS page, captured even when there are no messages yet
function restore() {
  try { const s=JSON.parse(sessionStorage.getItem(SKEY)||'null'); wasOpen=!!s?.open; if(!s?.msgs?.length) return false;
    msgs=s.msgs; escShown=s.escShown||false; lastEmail=s.lastEmail||null; start=s.start||start; pages=(s.pages||[]).map(scrubRef).filter(Boolean); titles=Object.fromEntries(Object.entries(s.titles||{}).map(([k,v])=>[scrubRef(k)||k,v])); recent=(Array.isArray(s.recent)?s.recent:[]).map((p)=>({...p,url:scrubRef(p&&p.url)})).filter((p)=>p.url); sentCount=s.sentCount||0; dropped=s.dropped||0; evalTok=evalTok||s.evalTok||'';
    notePage(); return true;
  } catch{return false;}
}
function renderRestored() {
  const c=$('psc-messages'); c.innerHTML=''; msgs.forEach(m=>m.role==='user'?userBubble(m.content,c):botBubble(m.content,c));
  if(escShown) escCard(c); scrollEnd();
}
let dropped=0; // turns trimmed from msgs, so sentCount can count the whole conversation
function trim() { const mx=MAX_TURNS*2; if(msgs.length>mx){ dropped+=msgs.length-mx; msgs=msgs.slice(msgs.length-mx); } }

// Nav tracking
function trackNav() { const h=location.href; if(h!==lastHref){lastHref=h; notePage();} noteTitle(); }
addEventListener('popstate',trackNav); addEventListener('hashchange',trackNav); setInterval(trackNav,2000);

// Recent products
function trackProduct() {
  // Scrubbed like every other page address: the raw one carried emails to the Worker (review 2026-09-28).
  if(pType()!=='product') return; const u=scrubRef(location.href)||(location.origin+location.pathname);
  if(recent.some(p=>p.url===u)) return;
  const t=document.querySelector('h1')?.textContent?.trim()||document.title.replace(/\s*[—–-]\s*Pine Street.*/i,'').trim()||'Product';
  const h=location.pathname.match(/\/products\/([^/?#]+)/)?.[1]||'';
  recent.push({title:t,handle:h,url:u}); if(recent.length>10) recent.shift(); save();
}

// Cart
async function fetchCart() {
  try { const opts={headers:{Accept:'application/json'}}; if(typeof AbortSignal!=='undefined'&&typeof AbortSignal.timeout==='function') opts.signal=AbortSignal.timeout(4000);
    const r=await fetch('/cart.js',opts); if(!r.ok) return;
    const d=await r.json(); if(d?.items) cart={items:d.items.map(i=>({title:i.title,variant_title:i.variant_title,quantity:i.quantity,final_line_price:i.final_line_price,handle:i.handle})),total_price:d.total_price,item_count:d.item_count};
  } catch{}
}

// Visitor IP is stamped SERVER-side now (the Worker knows it, proxy-aware).
// The old ipify.org call made every visitor's browser hit a third-party
// service - a privacy smell, blocked by many extensions anyway. Removed
// 2026-08-28 at Nick's IP/geo request.
function shopEmail() { return window.Shopify?.customerEmail||document.querySelector('meta[name="customer-email"]')?.getAttribute('content')||null; }
// Page titles ride along with every URL we report (Nick 2026-09-21: the emails
// showed only a URL, and a product handle is not a product name). h1 first, then
// document.title without the store suffix.
function pageTitle(){ try { const h=document.querySelector('h1')?.textContent?.trim(); const t=document.title.replace(/\s*[\u2014\u2013-]\s*Pine Street.*$/i,'').trim(); return (h||t||'').slice(0,120); } catch { return ''; } }
function noteTitle(){ try { const t=pageTitle(), r=pageRef(); if(t&&r) titles[r]=t; } catch {} }
// Device details for the transcript and contact emails (Nick 2026-10-20): window and screen size, pixel ratio, whether
// the full-screen phone layout applies, and on Chromium browsers the real model and OS version, which the agent string
// hides ("Android 10; K" is frozen by Chrome). Asked for once per page and never waited for; Safari and Firefox do not
// offer them, and then only the sizes are sent.
let hints=null;
try { navigator.userAgentData?.getHighEntropyValues?.(['model','platformVersion']).then((v)=>{ hints={model:String(v.model||'').slice(0,40),os:String(v.platformVersion||'').slice(0,20)}; }).catch(()=>{}); } catch {}
function devData(){ try { const d={w:innerWidth,h:innerHeight,sw:screen.width,sh:screen.height,dpr:Math.round((devicePixelRatio||1)*1000)/1000,full:matchMedia(PHONE_MQ).matches}; if(hints){d.model=hints.model;d.os=hints.os;} return d; } catch { return null; } }
function sessData() { noteTitle(); return {pageHistory:pages,pageTitles:titles,currentTitle:pageTitle(),sessionStart:start,currentPage:pageRef()||'(private page)',userAgent:navigator.userAgent||'?',device:devData()}; }
function ctx() { const c={url:pageUrl(),title:pageTitle()}; if(cart?.items?.length) c.cart=cart; if(recent.length) c.recentProducts=recent; return c; }

// Transcript: email a copy of the chat so it can be reviewed for training.
// Fires when the page goes away, which is the only reliable "conversation over"
// signal available client-side. sendBeacon survives unload; fetch does not.
//
// sentCount guards against duplicates: the widget persists across navigation, so
// pagehide fires on EVERY page change. We only send when there are new turns
// since the last send. A chat spanning several pages therefore arrives as a
// couple of emails rather than one, each carrying the full transcript so far.
function sendTranscript(reason) {
  if (dropped + msgs.length <= sentCount) return;
  const payload = JSON.stringify({
    endedReason: reason,
    messages: msgs,
    session: sessData(),
    email: lastEmail || shopEmail() || null,
    eval: evalTok || undefined,
  });
  sentCount = dropped + msgs.length; save();
  try {
    if (navigator.sendBeacon) {
      // text/plain, NOT application/json. A non-simple Content-Type makes the
      // beacon a preflighted CORS request, and beacons cannot preflight, so it
      // would fail silently on unload. The Worker parses the body as JSON
      // regardless of the header (verified 2026-08-28).
      const queued = navigator.sendBeacon(BASE+'/transcript', new Blob([payload], {type:'text/plain;charset=UTF-8'}));
      if(!queued) fetch(BASE+'/transcript', {method:'POST', headers:{'Content-Type':'text/plain;charset=UTF-8'}, body:payload, keepalive:true}).catch(()=>{});
    } else {
      fetch(BASE+'/transcript', {method:'POST', headers:{'Content-Type':'application/json'}, body:payload, keepalive:true});
    }
  } catch {}
}

// Health
async function checkHealth(notify=false) {
  try { const r=await fetch(BASE+'/health'); if(!r.ok) throw new Error('HTTP '+r.status);
    const d=await r.json().catch(()=>({})); if(d.ok) setOk(true); else throw new Error('not ok');
  } catch(e){setOk(false); if(notify) notifyDown(e.message);}
}
function setOk(ok) { healthy=ok; const l=$('psc-launcher'); if(ok){l?.classList.remove('is-disabled'); scheduleAuto();} else clearTimeout(autoT); }
// Reports "this browser could not reach the Worker" to the ALERT email stream.
// It previously masqueraded as a HelpScout customer named "PSC Monitor" via
// /contact, landing failures in the support queue (confused Nick on launch
// day). text/plain keeps the request CORS-simple, same trick as the transcript
// beacon, so it has the best chance of surviving whatever broke /chat.
async function notifyDown(err) { try{await fetch(BASE+'/client-alert',{method:'POST',headers:{'Content-Type':'text/plain;charset=UTF-8'},body:JSON.stringify({error:String(err).slice(0,300),page:pageRef()||'(private page)',userAgent:navigator.userAgent,eval:evalTok||undefined}),keepalive:true});}catch{} }
function scheduleAuto() { clearTimeout(autoT); if(open) return; const d=(AUTO_DELAY[pType()]??0)*1000; if(d<=0) return; autoT=setTimeout(()=>{if(!open&&healthy){openChat();track('chat_auto_open',{page_type:pType()});}},d); }

// Init
document.addEventListener('DOMContentLoaded', async()=>{
  // Mode check: 'preview' requires ?psc_chat=preview in URL; 'live' always shows
  const mode = $('psc-launcher')?.dataset.mode || 'preview';
  if (mode === 'preview' && !new URLSearchParams(location.search).has('psc_chat')) return; // silently exit, widget stays hidden

  $('psc-launcher').classList.add('is-active'); // shown only when no header button is visible
  $('psc-launcher').addEventListener('click',toggle);
  placeHeaderHelp();
  let hdrT=null; addEventListener('resize',()=>{ clearTimeout(hdrT); hdrT=setTimeout(placeHeaderHelp,250); });
  addEventListener('pageshow',placeHeaderHelp);
  $('psc-contact-btn').addEventListener('click',openContact);
  $('psc-close-btn').addEventListener('click',closeChat);
  $('psc-close-input')?.addEventListener('click',closeChat);
  $('psc-send').addEventListener('click',send);
  const inp=$('psc-input');
  inp.addEventListener('keydown',handleKey);
  // Escape closes from anywhere in the panel (a chip, the Contact button, the card).
  $('psc-panel').addEventListener('keydown',(e)=>{ if(e.key==='Escape'){ e.preventDefault(); closeChat(); } });
  inp.addEventListener('input',()=>{autoResize(inp);updateCounter(inp);});
  inp.addEventListener('blur',realign);
  // The phone input row also holds the Close pill, so the long placeholder clipped.
  if(isPhone()) inp.placeholder='Ask a question';
  // READY WATCHDOG (2026-09-23). The "Connecting to Pine Street Clinic" overlay is
  // hidden only once initialisation finishes, but the launcher already works, so a
  // hung cart request or a thrown step left a customer looking at a frozen panel:
  // overlay up, input and send disabled, no greeting ("none of the buttons or
  // fields work ... it's all frozen", email 2026-09-23). Whatever happens below,
  // the widget becomes usable within five seconds.
  // Idempotent by what is on screen, not by a flag, so it can run from the normal
  // path, the watchdog, a thrown step, or PSCChat.ready() in any order.
  const becomeReady=()=>{ try{ $('psc-overlay').style.display='none'; $('psc-send').disabled=false; $('psc-input').disabled=false; if(!$('psc-messages').children.length){ addBot(greeting()); chips(); } }catch(e){ console.error('psc chat ready step failed:', e); } };
  const watchdog=setTimeout(()=>{ console.warn('psc chat: initialisation did not finish in 5s, forcing ready'); becomeReady(); },5000);
  try {
  // The cart is fetched before each send; nothing here needs it (review 2026-09-23).
  if(restore()) renderRestored(); else if(!$('psc-messages').children.length){addBot(greeting());chips();}
  // trackProduct MUST run after restore(): it calls save(), and a save before
  // restore clobbers the stored session with pre-restore defaults - which
  // silently wiped the conversation AND the open-panel flag on every landing
  // on a product page (found live 2026-08-28 when the panel refused to stay
  // open across a click onto a product).
  trackProduct();
  } catch(e) { console.error('psc chat init step failed:', e); }
  clearTimeout(watchdog); becomeReady();
  // Stay open across same-site navigation (Nick 2026-08-28). The bot's own
  // answers link to product pages, and product data loads from the CURRENT
  // page - so following a bot link must not feel like losing the conversation.
  // The messages were already restored above; this restores the PANEL.
  // Phones: keep the conversation but do not reopen the full-screen panel after a
  // navigation (2026-09-18: a mis-hit tap navigated and the reopened panel read as
  // "back where I started"). The launcher shows Help; one tap brings it back.
  if(wasOpen && !isPhone()) openChat({restore:true});
  // LAZY HEALTH (2026-08-28): the widget used to call the Worker on EVERY page
  // load for EVERY visitor. That meant (a) one Worker invocation per pageview
  // store-wide, and (b) JS-executing crawlers tripped "client-side failure"
  // alerts while merely browsing - a scraper fleet on stale Chrome 133 proved
  // it within hours of launch. Now the Worker is only contacted once someone
  // actually opens the chat, so alerts can only come from engaged humans.
  // Deep link: any URL ending in #chat opens the widget on arrival, and any
  // on-page <a href="#chat"> opens it instantly without a reload. This replaces
  // the old HelpScout "get quick answers" link on /pages/contact - point such
  // links at https://pinestreetclinic.com/pages/contact#chat (Nick 2026-08-28).
  const wantChatHash = () => location.hash === '#chat';
  if (wantChatHash()) setTimeout(openChat, 200);
  addEventListener('hashchange', ()=>{ if(wantChatHash()) openChat(); });
  document.addEventListener('click', (e)=>{
    const a = e.target && e.target.closest && e.target.closest('a[href="#chat"]');
    if (a) { e.preventDefault(); openChat(); }
  });
  // Tiny public API so theme sections or page buttons can open the chat
  // directly: onclick="PSCChat.open()".
  window.PSCChat = { open: openChat, close: closeChat, ready: becomeReady };

  // pagehide covers navigation and tab close. visibilitychange catches mobile
  // Safari, where pagehide is unreliable when the app is backgrounded.
  addEventListener('pagehide', ()=>sendTranscript('pagehide'));
  document.addEventListener('visibilitychange', ()=>{ if(document.visibilityState==='hidden') sendTranscript('hidden'); });
});

// Contact
async function contact(payload) {
  // Older iOS has no AbortSignal.timeout; without a timeout a hung request left the
  // form stuck at '...' for good (2026-09-24). AbortController works everywhere.
  const ac=(typeof AbortController!=='undefined')?new AbortController():null; const tt=ac?setTimeout(()=>ac.abort(),15000):null;
  try { const opts={method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)}; if(ac) opts.signal=ac.signal;
    const r=await fetch(BASE+'/contact',opts); if(tt) clearTimeout(tt);
    const d=await r.json().catch(()=>({})); const safeUrl=(u)=>{ try{ return new URL(u).origin===location.origin?u:FALLBACK; }catch{ return FALLBACK; } };
    if(d.ok===false) return {ok:false,fallback_url:safeUrl(d.fallback_url||FALLBACK)}; return {ok:r.ok&&d.ok===true};
  } catch{ if(tt) clearTimeout(tt); return {ok:false,fallback_url:FALLBACK}; }
}

let submitting=false;
async function submitEsc() {
  if(submitting) return;
  const eE=$('psc-esc-email'), eErr=$('psc-esc-email-err'), mE=$('psc-esc-msg'), mErr=$('psc-esc-msg-err'), btn=$('psc-esc-btn');
  const email=eE?.value.trim()||'', msg=mE?.value.trim()||'';
  let err=false;
  if(eE&&eE.type!=='hidden'){if(!email||!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){eE.classList.add('invalid');eErr?.classList.add('visible');if(!err)eE.focus();err=true;}else{eE.classList.remove('invalid');eErr?.classList.remove('visible');}}
  if(!msg){mE?.classList.add('invalid');mErr?.classList.add('visible');if(!err)mE?.focus();err=true;}else{mE?.classList.remove('invalid');mErr?.classList.remove('visible');}
  if(err) return;
  submitting=true; btn.disabled=true; btn.textContent='...'; lastEmail=email; save(); track('escalation_submitted');
  // No invented name: the local part of an email address is not a person's name
  // (a ticket arrived as "Chat - maibar20210", Nick 2026-09-21). Send a name only
  // if the customer typed one; the Worker builds the subject from the page title.
  const name=($('psc-esc-name')?.value||'').trim().slice(0,80);
  const result=await contact({name:name||undefined,email,customerMessage:msg,conversation:msgs,session:sessData(),eval:evalTok||undefined});
  const card=document.querySelector('.psc-esc-card');
  if(card){
    if(result.ok) card.innerHTML='<p style="margin:0"><strong style="color:var(--psc-green)">\u2713 Got it</strong> \u2014 someone from our team will be in touch soon.</p>';
    else{const u=result.fallback_url||FALLBACK; card.innerHTML='<p style="margin:0">Something went wrong. Please <a href="'+u+'" target="_blank" rel="noopener" style="color:var(--psc-red);font-weight:600">contact us directly</a>.</p>';}
  }
  submitting=false; escShown=false; save();
  const sr=$('psc-sr'); if(sr){ sr.textContent=''; requestAnimationFrame(()=>{ sr.textContent=result.ok?'Message sent. Someone from our team will be in touch soon.':'Something went wrong. Please use the contact page.'; }); }
}

// Rendering
function settle(m){ m.addEventListener('animationend',()=>{ m.style.animation='none'; },{once:true}); return m; }
function botBubble(content,c) { const m=settle(document.createElement('div'));m.className='psc-msg bot'; const b=document.createElement('div');b.className='psc-bubble';b.innerHTML=renderMd(content);m.appendChild(b);c.appendChild(m);return m; }
function userBubble(text,c) { const el=settle(document.createElement('div'));el.className='psc-msg user';el.innerHTML='<div class="psc-bubble">'+esc(text)+'</div>';c.appendChild(el);return el; }

function addBot(raw) {
  const hasEsc=/##ESCALATION##/i.test(raw);
  const hasClose=/##CLOSE##/i.test(raw);
  const clean=raw.replace(/##(ESCALATION|CLOSE)##/gi,'').replace(/[ \t]{2,}/g,' ').replace(/\n{3,}/g,'\n\n').trim();
  const c=$('psc-messages');
  if(hasEsc&&!clean){if(!escShown){escShown=true;save();escCard(c);scrollEnd();}return;}
  const bubbleEl=botBubble(clean,c); scrollEnd();
  if(hasClose) closeButton(bubbleEl);
  const sr=$('psc-sr'); if(sr){sr.textContent='';requestAnimationFrame(()=>{sr.textContent=clean.replace(/<[^>]+>/g,'').substring(0,200);});}
  if(hasEsc&&!escShown){escShown=true;save();setTimeout(()=>escCard(c),350);}
  return bubbleEl;
}

// Thumbs up/down on a single answer. A thumbs down is the clearest possible
// signal of "this one was wrong", and far better than inferring it from the
// wording of the reply. Only shown on real answers, never on the greeting,
// an error, or an escalation card.
function attachFeedback(msgEl, question, answer) {
  if(!msgEl) return;
  const wrap=document.createElement('div'); wrap.className='psc-fb';
  const label=document.createElement('span'); label.className='psc-fb-done';
  label.textContent='Was this helpful?'; wrap.appendChild(label);
  const mk=(txt,rating,aria)=>{
    const b=document.createElement('button');
    b.className='psc-fb-btn'; b.textContent=txt; b.setAttribute('aria-label',aria);
    b.addEventListener('click',()=>rate(rating));
    return b;
  };
  const rate=async(rating)=>{
    wrap.innerHTML='';
    const done=document.createElement('span'); done.className='psc-fb-done';
    done.textContent = rating==='up' ? 'Thanks!' : 'Thanks \u2014 we\u2019ll take a look at this one.';
    wrap.appendChild(done);
    track('chat_feedback',{rating});
    try{
      await fetch(BASE+'/feedback',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({rating,question,answer,page:pageRef()||'(private page)',title:pageTitle(),eval:evalTok||undefined})});
    }catch{}
  };
  wrap.appendChild(mk('\uD83D\uDC4D','up','This answer was helpful'));
  wrap.appendChild(mk('\uD83D\uDC4E','down','This answer was not helpful'));
  msgEl.appendChild(wrap); scrollEnd();
}

function addUser(t) { userBubble(t,$('psc-messages')); scrollEnd(); }

// NN/g's chatbot study found people often do not know what an on-site bot is
// FOR, so they ignore it or ask it things it cannot do. One plain line of scope
// costs nothing and targets that directly.
function addCapabilities() {
  const c=$('psc-messages'), d=document.createElement('div');
  d.className='psc-cap';
  d.textContent='I\'m an AI assistant. I can help with product details, orders, shipping and returns.';
  c.appendChild(d); scrollEnd();
}

// EASY TO CHANGE: these three buttons are just strings, edit them freely.
// The previous set was ["Where's my order?", "How long does shipping take?",
// "What products contain magnesium?"]. The first two were the exact HelpScout
// Beacon buttons that opened the most UNRESOLVED conversations (28 and 15), and
// the third asks the widget to list products by ingredient, which it cannot do:
// it has no catalog search, only the current product page. These point at what
// it genuinely answers well.
// Page-aware, like the greeting: "What's in this product?" only makes sense ON
// a product page. Offering it on the homepage sent customers into a clarify
// round-trip for a question the button itself suggested (Nick, launch day).
function promptsFor() {
  return pType()==='product'
    ? ["What's in this product?","Sizes & prices","Returns & refunds"]
    // Nick 2026-09-25: "do you have / do you carry X" is the commonest typed intent on
    // non-product pages while these chips were barely tapped (9 taps in 30 days on the
    // home page; "Returns & refunds" 2 taps anywhere). The bot answers the new chip by
    // asking what they are looking for, then searches the catalog.
    : ["Help me find a product","How do I track my order?","Shipping & delivery"];
}
function chips() { const c=$('psc-messages'),w=document.createElement('div');w.className='psc-chips';w.id='psc-chips'; promptsFor().forEach(p=>{const b=document.createElement('button');b.className='psc-chip';b.textContent=p;b.addEventListener('click',()=>sendChip(p));w.appendChild(b);}); c.appendChild(w);scrollEnd(); }
function sendChip(t) { const c=$('psc-chips');if(c)c.remove(); $('psc-input').value=t;updateCounter($('psc-input'));send(); }

// ##CLOSE## in a reply = the customer asked how to close the chat. Render a
// big button under the reply so one tap does it. Not persisted across pages:
// after a restore the header Close is there and the moment has passed.
function closeButton(msgEl){ if(!msgEl||msgEl.querySelector('.psc-close-inline')) return; const b=document.createElement('button'); b.type='button'; b.className='psc-close-inline'; b.setAttribute('aria-label','Close chat'); b.textContent='\u2715 Close this chat'; b.addEventListener('click',closeChat); msgEl.appendChild(b); scrollEnd(); }

function escCard(container) {
  if($('psc-esc-email')) return;
  const se=shopEmail();
  const card=document.createElement('div');card.className='psc-esc-card';card.setAttribute('role','form');
  card.innerHTML='<p><strong>Want our team to follow up?</strong><br>Leave your details and we\'ll reply directly.</p>'+
    (se?'<div style="font-size:0.78rem;color:var(--psc-ink-soft);margin-bottom:8px">Sending as <strong style="color:var(--psc-ink)">'+se+'</strong></div><input type="hidden" id="psc-esc-email" value="'+se+'" />'
      :'<div style="display:flex;gap:6px;margin-bottom:4px"><input class="psc-esc-email" id="psc-esc-email" type="email" placeholder="your@email.com" autocomplete="email" /></div><div class="psc-esc-error" id="psc-esc-email-err">Please enter a valid email.</div>')+
    '<div style="display:flex;gap:6px;margin-bottom:6px"><input class="psc-esc-email" id="psc-esc-name" type="text" placeholder="Your name (optional)" autocomplete="name" maxlength="80" /></div>'+
    '<textarea class="psc-esc-message" id="psc-esc-msg" placeholder="What can we help you with?" rows="3" maxlength="2000"></textarea>'+
    '<div class="psc-esc-error" id="psc-esc-msg-err">Please enter a message.</div>'+
    '<button type="button" class="psc-esc-send" id="psc-esc-btn" style="margin-top:8px">Send</button>';
  container.appendChild(card);scrollEnd();
  $('psc-esc-btn')?.addEventListener('click',submitEsc);
  $('psc-esc-msg')?.addEventListener('keydown',e=>{if(e.key==='Enter'&&(e.ctrlKey||e.metaKey)){e.preventDefault();submitEsc();}});
  // Phones: no automatic focus (2026-09-18). A popped keyboard plus a sub-16px field
  // zoomed the page and put the panel into the state three customers got stuck in.
  if(!isPhone()) setTimeout(()=>{ if(document.activeElement===$('psc-input')&&$('psc-input').value) return; (se?$('psc-esc-msg'):$('psc-esc-email'))?.focus(); },60);
}

// After about 10 s the dots alone look broken (Nick 2026-09-29): say it is still working. The
// longest answers take 20 to 40 s. The line goes with the dots when the reply or an error arrives.
let typingNoteT=null;
function showTyping() { const e=document.createElement('div');e.className='psc-typing';e.id='psc-typing';e.innerHTML='<div class="psc-dot"></div><div class="psc-dot"></div><div class="psc-dot"></div>';$('psc-messages').appendChild(e);scrollEnd(); clearTimeout(typingNoteT); typingNoteT=setTimeout(()=>{ const t=$('psc-typing'); if(!t||t.querySelector('.psc-typing-note')) return; const stick=nearBottom(); const n=document.createElement('span'); n.className='psc-typing-note'; n.textContent='Still working on it'; t.appendChild(n); const sr=$('psc-sr'); if(sr) sr.textContent='Still working on it'; if(stick) scrollEnd(); },10000); }
function hideTyping() { clearTimeout(typingNoteT); const e=$('psc-typing');if(e)e.remove(); }
function scrollEnd() { const c=$('psc-messages');requestAnimationFrame(()=>c.scrollTop=c.scrollHeight); }

// iOS keyboard. Safari shrinks the VISUAL viewport when the keyboard opens but
// leaves the layout viewport alone, so a full-screen fixed panel slides up with
// the page and its header - the only Close on a phone - leaves the screen while
// the input is focused. Two customers hit it (2026-09-07, 2026-09-08) and Nick
// reproduced it on his own iPhone 2026-09-08. While the panel is open on a
// phone, size it to the visual viewport instead; clear the override when the
// keyboard goes. Desktop is untouched (the early return clears any override).
let lastFitH=null;
function fitPanel(){
  const p=$('psc-panel'), vv=window.visualViewport; if(!p||!vv) return;
  const phone=isPhone();
  const full=Math.abs(vv.height-window.innerHeight)<2;
  if(!phone||!open||full){ p.style.top=''; p.style.height=''; p.style.bottom=''; lastFitH=null; return; }
  p.style.top=Math.max(0,vv.offsetTop)+'px'; p.style.height=vv.height+'px'; p.style.bottom='auto';
  // Scroll the thread to the end only when the HEIGHT changed (keyboard opened or
  // closed), never on a pan: snapping on every viewport scroll event made it
  // impossible to read older messages with the keyboard up (2026-09-18).
  const hh=Math.round(vv.height); if(hh!==lastFitH){ lastFitH=hh; scrollEnd(); }
}
if(window.visualViewport){ window.visualViewport.addEventListener('resize',fitPanel); window.visualViewport.addEventListener('scroll',fitPanel); }
// Safari's back-forward cache restores the page exactly as it was left, chat open
// and body locked included. On a phone, come back closed and unlocked (2026-09-18).
addEventListener('pageshow',(e)=>{ if(e.persisted&&isPhone()){ if(open) closeChat(); else unlockPage(); } });

// STAY ABOVE OTHER FLOATING WIDGETS (2026-09-23). UserWay's accessibility icon
// and the Google Merchant Center badge both use the maximum z-index and are
// appended to <body> after us, so they won every overlap: the badge renders as
// a full-width bottom bar on Android widths and covered the Help launcher, and
// the UserWay icon sat on the panel's Close button on iPad. Same z-index plus
// LAST in the DOM wins, so our two nodes are moved to the end of <body> at
// load, on open, on a timer, and whenever something new is appended.
// NEVER re-parent while the panel is open (2026-09-24, real customer, iPhone 13:
// "click close and it immediately opens again"). Moving the panel in the DOM
// between a tap's mousedown and mouseup makes WebKit drop the click, and the
// panel visibly disappears and re-inserts, which reads as reopening. The
// 2026-09-23 version did that on the input's blur, i.e. on the Close tap itself
// whenever a theme script had added a body child while the customer typed (the
// live site adds <script> nodes continuously). A pending move now waits for
// closeChat(); openChat() already moves before it opens.
let topPending=false;
function keepOnTop(){ try { const b=document.body, l=$('psc-launcher'), p=$('psc-panel'); if(!b||!l||!p) return; if(b.lastElementChild===p&&p.previousElementSibling===l){ topPending=false; return; } if(open){ topPending=true; return; } topPending=false; b.appendChild(l); b.appendChild(p); } catch {} }
let topTimer=null;
try { new MutationObserver((muts)=>{ if(muts.some((m)=>[...m.addedNodes].some((n)=>n.nodeType===1&&n.id!=='psc-launcher'&&n.id!=='psc-panel'))){ clearTimeout(topTimer); topTimer=setTimeout(keepOnTop,250); } }).observe(document.body,{childList:true}); } catch {}
[0,1500,4000,8000].forEach((ms)=>setTimeout(keepOnTop,ms));

// PHONE SCROLL LOCK. Third iPhone customer in ten days (2026-09-18, collection
// page): "every time I click close the page just reloads" - the tap aimed at
// Close landed on a product tile BEHIND the panel (the page they never meant to
// open is that tile's link). iOS 26 leaves fixed elements visibly offset from
// where it hit-tests them after the keyboard closes. Locking the page behind the
// panel is the standard modal pattern that keeps the layout and visual viewports
// from drifting apart, and the scroll reset on keyboard dismissal is the
// documented realignment nudge. Phones only; desktop is untouched.
let lockedY=null;
function isPhone(){ return matchMedia(PHONE_MQ).matches; }
let inerted=[];
function setInert(on){ try { const p=$('psc-panel'), l=$('psc-launcher'); if(on){ inerted=[...document.body.children].filter((el)=>el!==p&&el!==l&&!el.inert); inerted.forEach((el)=>{ el.inert=true; }); p.setAttribute('aria-modal','true'); } else { inerted.forEach((el)=>{ el.inert=false; }); inerted=[]; p.removeAttribute('aria-modal'); } } catch {} }
function lockPage(){ if(!isPhone()||lockedY!==null) return; setInert(true); lockedY=window.scrollY||0; const b=document.body; b.style.position='fixed'; b.style.top=(-lockedY)+'px'; b.style.left='0'; b.style.right='0'; b.style.width='100%'; b.style.overflow='hidden'; }
// The theme sets html{scroll-behavior:smooth}, so a plain scrollTo animated: after Close the page
// scrolled slowly down from the top instead of simply being where it was (review 2026-09-28).
function jumpTo(y){ const h=document.documentElement, sb=h.style.scrollBehavior; h.style.scrollBehavior='auto'; try { window.scrollTo(0,y); } finally { h.style.scrollBehavior=sb; } }
function unlockPage(){ if(lockedY===null) return; setInert(false); const b=document.body; b.style.position=''; b.style.top=''; b.style.left=''; b.style.right=''; b.style.width=''; b.style.overflow=''; const y=lockedY; lockedY=null; jumpTo(y); }
// The lock is checked again when the timer fires: a Close tap blurs the input first, and the
// scroll to 0 then ran after closeChat() had unlocked, leaving the page at the top (review 2026-09-28).
function realign(){ if(lockedY===null) return; setTimeout(()=>{ if(lockedY===null) return; jumpTo(0); fitPanel(); },60); }

// Only follow the stream if the customer is already at the bottom. NN/g flags
// forced autoscroll during streaming as an anti-pattern: it drags people away
// from text they are still reading.
function nearBottom() { const c=$('psc-messages'); return (c.scrollHeight-c.scrollTop-c.clientHeight) < 70; }

// While streaming, the send button becomes a stop button. Microsoft's streaming
// UX spec makes an interrupt mandatory, and it reuses space we already have.
let streaming=false;
function setStreaming(on) {
  streaming=on;
  const b=$('psc-send'); if(!b) return;
  b.disabled=false;
  b.setAttribute('aria-label', on?'Stop the reply':'Send message');
  b.title = on?'Stop':'Send';
  b.innerHTML = on
    ? '<svg width="13" height="13" viewBox="0 0 24 24"><rect x="5" y="5" width="14" height="14" rx="2" fill="white"/></svg>'
    : '<svg width="15" height="15" fill="none" viewBox="0 0 24 24"><path fill="white" d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>';
}

// Toggle
// One Help button right after each header search button (the theme renders desktop and mobile
// variants; whichever is visible is used). If none is visible the corner launcher is used.
let hdrHelp=[];
function placeHeaderHelp(){ try {
  hdrHelp=hdrHelp.filter((h)=>h.isConnected);
  for(const sb of document.querySelectorAll('header.site-header form.live-search-form button.live-search-button')){
    if(!sb.parentElement||sb.parentElement.querySelector('.psc-hdr-help')) continue;
    const b=document.createElement('button'); b.type='button'; b.className='psc-hdr-help is-active';
    b.setAttribute('aria-controls','psc-panel'); b.setAttribute('aria-expanded',open?'true':'false'); b.setAttribute('aria-label',open?'Close help chat':'Open help chat');
    b.innerHTML='<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path fill="currentColor" d="M20 2H4a2 2 0 00-2 2v18l4-4h14a2 2 0 002-2V4a2 2 0 00-2-2z"/></svg><span>'+(open?'Close':'Help')+'</span>';
    b.addEventListener('click',(e)=>{ e.preventDefault(); e.stopPropagation(); toggle(); });
    sb.insertAdjacentElement('afterend',b); hdrHelp.push(b);
  }
  // A header button hidden only because the theme's full-screen search is open still counts: it
  // is back when the search closes, and the corner button must not appear beside it then.
  // Phones only (2026-09-29): a narrow window that is not a phone never shows the header button, so
  // counting one hidden by the search left it with no chat button at all after a resize.
  const inHeader=hdrHelp.some((h)=>h.getBoundingClientRect().width>0||(isPhone()&&!!h.closest('.live-search--takeover')));
  $('psc-launcher').classList.toggle('psc-in-header',inHeader);
} catch {} }
function visibleHeaderHelp(){ return hdrHelp.find((h)=>h.isConnected&&h.getBoundingClientRect().width>0)||null; }
function setLauncherLabel(t){ const l=$('psc-launcher-label'); if(l) l.textContent=t; const lab=t==='Close'?'Close help chat':'Open help chat'; const b=$('psc-launcher'); if(b) b.setAttribute('aria-label',lab); for(const h of hdrHelp){ h.setAttribute('aria-label',lab); h.setAttribute('aria-expanded',t==='Close'?'true':'false'); const sp=h.querySelector('span'); if(sp) sp.textContent=t; } }
let healthStarted=false;
function startHealth(){ if(healthStarted) return; healthStarted=true; checkHealth(true); hInterval=setInterval(()=>checkHealth(true),HEALTH_MS); }
// opts.restore reopens after navigation: no keyboard-focus steal (on mobile a
// focused input pops the keyboard on every page load) and no chat_open
// analytics event (the customer opened the chat once, not once per page).
function openChat(opts) { const rst=!!(opts&&opts.restore); keepOnTop(); startHealth(); setLauncherLabel('Close'); open=true;$('psc-panel').classList.add('is-open');const l=$('psc-launcher');l.classList.add('is-open');l.setAttribute('aria-expanded','true');if(!rst&&!isPhone())setTimeout(()=>$('psc-input').focus(),280);scrollEnd();lockPage();fitPanel();if(!rst)track('chat_open',{page_type:pType()});save(); }
// unlockPage() sits in a finally: if anything else in here ever threw, the page
// would stay position:fixed and inert behind a hidden panel, i.e. dead (2026-09-24).
function closeChat() { open=false; try { setLauncherLabel('Help'); $('psc-panel').classList.remove('is-open'); if(topPending) keepOnTop(); fitPanel(); } finally { unlockPage(); } const l=$('psc-launcher'); l.classList.remove('is-open'); l.setAttribute('aria-expanded','false'); try { (visibleHeaderHelp()||l).focus({preventScroll:true}); } catch {} save(); }
function toggle() { open?closeChat():openChat(); }
function openContact() {
  startHealth();
  if(!open){open=true;setLauncherLabel('Close');$('psc-panel').classList.add('is-open');$('psc-launcher').classList.add('is-open');$('psc-launcher').setAttribute('aria-expanded','true');scrollEnd();lockPage();fitPanel();save();}
  if(!escShown){escShown=true;save();escCard($('psc-messages'));}
  else document.querySelector('.psc-esc-card')?.scrollIntoView({behavior:'smooth',block:'nearest'});
}

// Send
// A close request is never a reason to show the contact form, however loud it is
// typed (2026-09-18): the Worker's close rule forbids the card, and the widget's
// own shouting heuristic used to add it anyway, client-side.
const CLOSE_REQ=/\b(close|hide|minimi[sz]e|dismiss|exit|get rid of|shut|turn off|remove)\b[^.!?]{0,25}\b(this|it|the|your|that)?\s*(chat|window|assistant|bot|ai|menu|box|pop-?up|widget|help|screen|thing)\b|\bso (i|we) can (actually )?(shop|see|use|browse)\b/i;
function frustration(t) { if(escShown||CLOSE_REQ.test(t)) return false; const lt=t.replace(/[^a-zA-Z]/g,''); return lt.length>8&&lt.replace(/[^A-Z]/g,'').length/lt.length>0.65; }

async function send() {
  // A stale "unhealthy" flag used to refuse every message for up to 5 minutes after
  // ONE failed request (review 2026-09-23). Re-check first; refuse only if still down.
  if(healthy===false){ await checkHealth(); if(healthy===false){ addBot("I'm having trouble connecting right now. You can reach our team through our [contact page](https://pinestreetclinic.com/pages/contact)."); return; } }
  if(streaming){ if(abort){abort.abort();abort=null;} setStreaming(false); return; }
  const inp=$('psc-input'),text=inp.value.trim(); if(!text||loading) return;
  if(abort){abort.abort();abort=null;}
  inp.value='';inp.style.height='auto';updateCounter(inp); loading=true;$('psc-send').disabled=true;lastMsg=text;
  const ch=$('psc-chips');if(ch)ch.remove();
  addUser(text); msgs.push({role:'user',content:text}); trim();save(); track('message_sent',{page_type:pType()});
  if(frustration(text)&&!escShown){escShown=true;save();setTimeout(()=>escCard($('psc-messages')),200);track('escalation_triggered',{trigger:'frustration'});}
  await fetchCart();
  showTyping(); abort=new AbortController(); const to=setTimeout(()=>{if(abort)abort.abort();},TIMEOUT);
  try {
    // STREAMING IS OFF (Nick 2026-08-28: accuracy over speed).
    // Streaming does not make answers less accurate, but it does make them
    // impossible to intercept: once tokens are on screen they cannot be unsaid.
    // With it off, the Worker inspects the finished reply and can REPLACE a
    // confirmed rule violation before the customer ever sees it. Clean replies
    // are not slowed down; only a flagged one pays for the review call.
    // The streaming path below still works, verified by eval/streaming.test.mjs.
    // To re-enable, set canStream back to the capability check.
    const canStream = false;
    const r=await fetch(BASE+'/chat',{method:'POST',signal:abort.signal,headers:{'Content-Type':'application/json'},body:JSON.stringify({stream:canStream,caps:['close'],messages:msgs,context:ctx(),eval:evalTok||undefined})});
    clearTimeout(to);
    if(!r.ok){abort=null;const e=await r.json().catch(()=>({}));if(r.status===401)throw new Error('auth');if(r.status===429)throw new Error('ratelimit');if(r.status>=500)throw new Error('server');throw new Error(e.error?.message||'HTTP '+r.status);}

    let reply='';
    const isSSE=(r.headers.get('Content-Type')||'').includes('text/event-stream');
    if(isSSE && r.body && r.body.getReader){
      // Stream into a live bubble. Partial text is written with textContent, not
      // markdown: half a link or half a list renders as broken markup and the
      // customer watches it flicker. Markdown is applied once, at the end.
      hideTyping(); setStreaming(true);
      const el=botBubble('',$('psc-messages')); const bub=el.firstChild;
      const reader=r.body.getReader(), dec=new TextDecoder(); let buf='';
      for(;;){
        const {done,value}=await reader.read();
        if(done) break;
        buf+=dec.decode(value,{stream:true});
        const lines=buf.split('\n'); buf=lines.pop();
        for(const line of lines){
          if(!line.startsWith('data:')) continue;
          try{
            const ev=JSON.parse(line.slice(5).trim());
            if(ev.type==='content_block_delta'&&ev.delta&&typeof ev.delta.text==='string'){
              reply+=ev.delta.text;
              bub.textContent=reply.replace(/##(ESCALATION|CLOSE)##/gi,'').replace(/##[A-Z]{0,10}#{0,2}\s*$/,'');
              if(nearBottom()) scrollEnd();
            }
          }catch{}
        }
      }
      setStreaming(false); abort=null;
      const cleanS=reply.replace(/##(ESCALATION|CLOSE)##/gi,'').replace(/[ \t]{2,}/g,' ').replace(/\n{3,}/g,'\n\n').trim();
      if(!cleanS && !/##(ESCALATION|CLOSE)##/i.test(reply)) throw new Error('empty stream');
      bub.innerHTML=renderMd(cleanS);
      const sr=$('psc-sr'); if(sr){sr.textContent='';requestAnimationFrame(()=>{sr.textContent=cleanS.replace(/<[^>]+>/g,'').substring(0,200);});}
      if(/##ESCALATION##/i.test(reply)&&!escShown){escShown=true;save();setTimeout(()=>escCard($('psc-messages')),350);}
      if(/##CLOSE##/i.test(reply)) closeButton(el);
      if(!cleanS) el.remove();
      msgs.push({role:'assistant',content:cleanS}); trim();save();
      if(cleanS) attachFeedback(el,text,cleanS);
      setOk(true); scrollEnd();
    } else {
      // Non-streaming fallback: an older browser, or the Worker answered JSON
      // because the upstream call failed before a stream could start.
      abort=null;
      const data=await r.json(); reply=data.content?.[0]?.text||"I didn't receive a response \u2014 please try again.";
      const clean=reply.replace(/##(ESCALATION|CLOSE)##/gi,'').replace(/[ \t]{2,}/g,' ').replace(/\n{3,}/g,'\n\n').trim();
      msgs.push({role:'assistant',content:clean}); trim();save();hideTyping();
      const botEl=addBot(reply); attachFeedback(botEl,text,clean); setOk(true);
    }
  } catch(err) {
    try {
    clearTimeout(to);abort=null;hideTyping();setStreaming(false);
    if(err.name==='AbortError') retryBubble('Response is taking too long. Please try again.');
    else if(err.message==='auth') addBot("Service configuration issue. Please try later.");
    else if(err.message==='ratelimit') addBot("Lots of requests right now \u2014 please try again in a moment.");
    else if(err.message==='server'||/fetch|network|Failed/i.test(err.message)){setOk(false);notifyDown(err.message);retryBubble("I couldn't reach our chat service just now. Please try again.");}
    else addBot("Something went wrong \u2014 please try again.");
    } catch {}
  } finally {
    loading=false;setStreaming(false);$('psc-send').disabled=false;
  }
  // Back to the chat box only when the chat is OPEN and the keyboard is not somewhere else
  // (2026-09-29): a reply arriving after Close pulled it out of the store's search box, and the rest
  // of the customer's word was typed into the hidden chat box.
  if(!isPhone()&&open){ const ae=document.activeElement; if(!ae||ae===document.body||$('psc-panel').contains(ae)) $('psc-input').focus(); }
}

// One retry bubble for the timeout and the server/network paths (the latter used to
// render nothing at all, review 2026-09-23). The retry re-sends the last message
// without pushing it into the history twice.
function retryBubble(msg){ const c=$('psc-messages'),w=document.createElement('div');w.className='psc-msg bot';w.innerHTML='<div class="psc-bubble">'+esc(msg)+'</div>'; const rb=document.createElement('button');rb.type='button';rb.className='psc-retry';rb.textContent='\u21A9 Try again';rb.addEventListener('click',()=>{w.remove(); if(msgs.length&&msgs[msgs.length-1].role==='user'&&msgs[msgs.length-1].content===lastMsg) msgs.pop(); $('psc-input').value=lastMsg||'';updateCounter($('psc-input'));send();});w.appendChild(rb);c.appendChild(w);scrollEnd(); const sr=$('psc-sr'); if(sr){ sr.textContent=''; requestAnimationFrame(()=>{ sr.textContent=msg; }); } }
// The return key sends (2026-09-25: an iPhone customer hit return, which sits next to
// the space bar, mid-word and split a question in two). enterkeyhint="send" on the
// textarea labels the key "send" so it says what it does; behaviour is unchanged.
function handleKey(e) { if(e.isComposing||e.keyCode===229) return; if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();send();} }
function autoResize(el) { el.style.height='auto';el.style.height=Math.min(el.scrollHeight,110)+'px'; }
function updateCounter(inp) { const c=$('psc-counter');if(!c)return;const l=inp.value.length;c.textContent=l+' / '+MAX_CHARS; c.setAttribute('aria-live', l>=MAX_CHARS*0.8?'polite':'off');c.className='psc-counter'+(l>=MAX_CHARS?' at':l>=MAX_CHARS*.8?' near':''); }

// Markdown. Image and link hosts are matched by EXACT hostname (review
// 2026-09-23: a substring check let evil.example/x?cdn.shopify.com through, and an
// unescaped src attribute let a crafted image link inject an onerror handler).
const hostOf=(u)=>{try{return new URL(u).hostname.toLowerCase()}catch{return ''}};
const IMG_HOSTS=['cdn.shopify.com','pinestreetclinic.com','www.pinestreetclinic.com'];
const OWN_HOSTS=['pinestreetclinic.com','www.pinestreetclinic.com','account.pinestreetclinic.com'];
const attr=(v)=>String(v).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
function renderMd(text) {
  const images=[]; text=text.replace(/!\[([^\]]*)\]\((https?:\/\/[^)]+)\)/g,(_,a,u)=>{images.push({a,u});return '\x00I'+(images.length-1)+'\x00';});
  // Link hrefs: an EXPLICIT scheme allowlist (http/https/mailto/tel) - never
  // arbitrary schemes, so javascript: cannot be captured. mailto: was missing,
  // which left a practitioner's email rendering as raw [text](mailto:...) markup.
  const links=[]; text=text.replace(/\[([^\]]+)\]\(((?:https?:\/\/|mailto:|tel:)[^)]+)\)/g,(_,l,u)=>{links.push({l,u});return '\x00L'+(links.length-1)+'\x00';});
  text=esc(text);
  text=text.replace(/\*\*([^*]+)\*\*/g,'<strong>$1</strong>');
  text=text.replace(/\*([^*]+)\*/g,'<em>$1</em>');
  let lines=text.split('\n');
  lines=lines.flatMap(line=>{
    if(/^\s*[-*]\s/.test(line))return[line]; if(/^\s*\d+\.\s/.test(line))return[line];
    const cd=line.match(/^(.+?:\s*)(-\s+.+)$/); if(cd)return[cd[1].trim(),cd[2]];
    const cn=line.match(/^(.+?:\s*)(\d+\.\s+.+)$/); if(cn)return[cn[1].trim(),cn[2]];
    const m=line.match(/^(.+:\s*)[-\u2013]\s+(\x00L\d+\x00.*)$/); if(m)return[m[1].replace(/:\s*$/,':'),'- '+m[2]];
    return[line];
  });
  const out=[];let inL=false;
  for(const line of lines){const ul=line.match(/^\s*[-*]\s+(.+)$/);const ol=!ul&&line.match(/^\s*\d+\.\s+(.+)$/);
    if(ul||ol){if(!inL){out.push('<ul>');inL=true;}out.push('<li>'+(ul||ol)[1]+'</li>');}
    else{if(inL){out.push('</ul>');inL=false;}out.push(line);}}
  if(inL)out.push('</ul>');
  let r='';for(let i=0;i<out.length;i++){const ln=out[i],blk=ln==='<ul>'||ln==='</ul>'||ln.startsWith('<li>');if(blk)r+=ln;else{if(i>0&&out[i-1]!=='<ul>')r+='<br>';r+=ln;}}
  r=r.replace(/\x00I(\d+)\x00/g,(_,i)=>{const{a,u}=images[+i];if(IMG_HOSTS.includes(hostOf(u)))return'<img class="psc-thumb" src="'+attr(u)+'" alt="'+attr(a)+'" loading="lazy" />';return'';});
  r=r.replace(/\x00L(\d+)\x00/g,(_,i)=>{const{l,u}=links[+i];const sl=l.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');const su=attr(u);const web=/^https?:\/\//i.test(u);const ext=web&&!OWN_HOSTS.includes(hostOf(u));return'<a href="'+su+'"'+(ext?' target="_blank" rel="noopener noreferrer"':'')+'>'+sl+'</a>';});
  return r;
}
})();
